import createSvgIcon from '../Utils/CreateSvgIcon';

//THIS IS A TEMP ICON THAT CAN BE USED ON WHITE BACKGROUNDS - DESIGN TEAM TO PROVIDE FINAL ICON
export const LayoutList = createSvgIcon(
  <svg fill="none">
    <path
      d="M6.66667 9.3335H2V14.0002H6.66667V9.3335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 2H2V6.66667H6.66667V2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33594 2.6665H14.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33594 6H14.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33594 10H14.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33594 13.3335H14.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'List',
  '0 0 16 16',
);
